"use client";

import React from "react";
import { Building2, ChartLine as LineChart, Award, ShieldCheck, Laptop, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const certifications = [{
  id: 1,
  title: "Revenue Management Certification",
  authority: "IHG",
  icon: "Building2",
  year: "2022"
}, {
  id: 2,
  title: "Google Analytics Individual Qualification",
  authority: "Google",
  icon: "LineChart",
  year: "2023"
}, {
  id: 3,
  title: "Certified Hospitality Revenue Manager (CHRM)",
  authority: "AHLEI",
  icon: "Award",
  year: "2021"
}, {
  id: 4,
  title: "Certified Revenue Management Executive (CRME)",
  authority: "HSMAI",
  icon: "ShieldCheck",
  year: "2020"
}, {
  id: 5,
  title: "Advanced Digital Marketing",
  authority: "Simplilearn",
  icon: "Laptop",
  year: "2023"
}];
const getIcon = (name: string) => {
  switch (name) {
    case 'Building2':
      return <Building2 className="w-8 h-8 text-secondary" />;
    case 'LineChart':
      return <LineChart className="w-8 h-8 text-secondary" />;
    case 'Award':
      return <Award className="w-8 h-8 text-secondary" />;
    case 'ShieldCheck':
      return <ShieldCheck className="w-8 h-8 text-secondary" />;
    case 'Laptop':
      return <Laptop className="w-8 h-8 text-secondary" />;
    default:
      return <CheckCircle2 className="w-8 h-8 text-secondary" />;
  }
};
export default function Certifications() {
  return <section id="certificationscredentials" className="py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8">
          <div className="max-w-2xl">
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
              Industry Credentials
            </h2>
            <p className="text-muted-foreground text-lg md:text-xl leading-relaxed">
              Demonstrated expertise through globally recognized hospitality, revenue management, and technology certifications.
            </p>
          </div>
          <div className="hidden md:block w-32 h-1 bg-secondary shrink-0 mb-2" />
        </div>

        <Separator className="mb-12 bg-border/50" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {certifications.map((cert, i) => <Card key={cert.id} data-index={i} className="bg-primary text-primary-foreground border-none rounded-md shadow-lg hover:-translate-y-1 transition-transform duration-300 flex flex-col h-full">
              <CardHeader className="pb-4 pt-8 px-8">
                <div className="mb-6 p-3 bg-primary-foreground/5 w-fit rounded-md">
                  {getIcon(cert.icon)}
                </div>
                <CardTitle className="font-default text-xl md:text-2xl font-semibold leading-snug">
                  {cert.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="mt-auto px-8 pb-8 pt-0">
                <Separator className="bg-primary-foreground/10 mb-6" />
                <div className="flex items-center justify-between">
                  <Badge variant="secondary" className="rounded-sm px-3 py-1 text-xs font-bold tracking-wider uppercase bg-secondary text-secondary-foreground">
                    {cert.authority}
                  </Badge>
                  <span className="text-primary-foreground/60 text-sm font-mono font-medium">
                    {cert.year}
                  </span>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}